/**
 * Merges two Maskito options objects. Array values are concatenated.
 *
 * @template TOptions - The base options type.
 * @param options - A list of base options.
 */ function mergeMaskitoOptions(...options) {
    return options.reduce((previous, option)=>{
        return {
            ...previous,
            ...option,
            preprocessors: [
                ...previous?.preprocessors ?? [],
                ...option?.preprocessors ?? []
            ],
            postprocessors: [
                ...previous?.postprocessors ?? [],
                ...option?.postprocessors ?? []
            ],
            plugins: [
                ...previous?.plugins ?? [],
                ...option?.plugins ?? []
            ]
        };
    }, {});
}

export { mergeMaskitoOptions };
//# sourceMappingURL=merge-maskito-options.js.map
